(ns ui.view.card.decisions.model)

(def expanded-decisions-path [:expanded-decisions])

(defn expanded-decisions-full-path
  [card-state-path]
  (into card-state-path expanded-decisions-path))

(def decision-conditions-table-default-columns
  (->> [:decision-condition/title
        :decision-condition/status
        :decision-condition/description]
       (mapv (fn [field]
               {:field field}))))

(def decision-participants-table-default-columns
  [{:label "Name"
    :field :decision-participant/person}
   {:field :decision-participant/attendance}
   {:field :decision-participant/role}
   {:field :decision-participant/notes}])

(def investment-reservation-table-default-columns
  [{:label "Type"
    :field :investment-reservation/type}
   {:field :investment-reservation/amount}
   {:field :investment-reservation/expiry-date}
   {:field :investment-reservation/void-date}
   {:field :investment-reservation/notes}
   {:field :investment-reservation/subtract-from-dry-powder}])

(def advisory-board-decision-details-default-fields
  [:decision/date
   :decision/meeting-type])

(def ic-decision-details-default-fields
  [:decision/date
   :decision/fund-has-sufficient-capacity
   :decision/complies-with-investment-strategy
   :decision/ic-approves-proposed-investment])

(def ic-exit-decision-details-default-fields
  [:decision/date
   :decision/ic-approves-proposed-exit])

(def aifm-decision-details-default-fields
  [:decision/date
   :decision/deciding-party
   :decision/portfolio-manager
   :decision/portfolio-manager-approves-proposed-investment
   :decision/pre-investment-checks-completed
   :decision/ic-recommended-to-fund
   :decision/fund-has-sufficient-capacity])

(def aifm-exit-decision-details-default-fields
  [:decision/date
   :decision/deciding-party
   :decision/portfolio-manager
   :decision/portfolio-manager-approves-proposed-exit
   :decision/pre-exit-checks-completed
   :decision/ic-recommended-the-exit
   :decision/fund-has-sufficient-capacity])

(def aifm-decision-approvals-needed-default-fields
  [:decision/board-approval-needed
   :decision/advisory-board-approval-needed])

(def aifm-exit-decision-approvals-needed-default-fields
  [:decision/advisory-board-approval-needed])
